import React, {Component} from 'react';
import {translate} from 'react-i18next';
import PageHeader from '../elements/PageHeader';
import moment from 'moment';
import 'moment/locale/de';
import config from '../../config/config.js';
import axios from 'axios';
import fileDownload from 'js-file-download';
import Datepicker from 'react-datepicker';
import {Link} from "react-router-dom";

class ShiftListsScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            startAt: moment(),
            endAt: moment().add(1, 'hour'),
            shiftsData: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleStartAtChange = this.handleStartAtChange.bind(this);
        this.handleEndAtChange = this.handleEndAtChange.bind(this);
        this.loadData = this.loadData.bind(this);
        this.printRoute = this.printRoute.bind(this);
    }

    componentDidMount() {
        this.setState({
            startAt: moment().format('DD.MM.YYYY HH:mm'),
            endAt: moment().add(1, 'hour').format('DD.MM.YYYY HH:mm')
        });
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleStartAtChange(date) {
        this.setState({
            startAt: moment(date).format('DD.MM.YYYY HH:mm'),
            endAt: moment(date).add(1, 'hour').format('DD.MM.YYYY HH:mm')
        });
    }

    handleEndAtChange(date) {
        this.setState({
            endAt: moment(date).format('DD.MM.YYYY HH:mm')
        });
    }

    loadData() {
        this.setState({
            loading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/shiftLists/', {
            method: 'post',
            data: {
                startAt: that.state.startAt,
                endAt: that.state.endAt
            }
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    loading: false,
                    shiftsData: response.data
                });
            }
        });
    }

    printRoute(routeId, routeName, startAt) {
        axios(config.server.endpoint + 'backend/shiftLists/route/' + routeId, {
            method: 'post',
            data: {
                startAt: moment(startAt).format('DD.MM.YYYY HH:mm')
            },
            responseType: 'blob'
        }).then((response) => {
            if (response.status === 200) {
                fileDownload(response.data, 'route_' + routeName.replace(/[^0-9a-zA-z]+/g, "-") + '.pdf', 'application/pdf');
            }
        });
    }

    render() {
        const {t} = this.props;
        return (
            <div className="ShiftListsScreen">
                <PageHeader title={t('shiftLists.title')} loading={this.state.loading}/>
                <div className="row m-t">
                    <div className="col-xs-12">
                        <h3>
                            {t('shiftLists.filter.title')}
                        </h3>
                    </div>
                    <div className="col-xs-12">
                        <div className="form-group inline">
                            <label>
                                {t('shiftLists.filter.startAt.title')}
                            </label>
                            <Datepicker
                                selected={this.state.startAt ? moment(this.state.startAt, 'DD.MM.YYYY HH:mm') : null}
                                dateFormat="DD.MM.YYYY HH:mm" locale={moment.locale('de')}
                                timeFormat="HH:mm"
                                className="form-control"
                                value={this.state.startAt}
                                showTimeSelect
                                timeCaption="time"
                                onChange={this.handleStartAtChange}/>
                        </div>
                        <div className="form-group inline">
                            <label>
                                {t('shiftLists.filter.endAt.title')}
                            </label>
                            <Datepicker
                                selected={this.state.endAt ? moment(this.state.endAt, 'DD.MM.YYYY HH:mm').add('hour', 1) : null}
                                dateFormat="DD.MM.YYYY HH:mm" locale={moment.locale('de')}
                                timeFormat="HH:mm"
                                className="form-control"
                                value={this.state.endAt}
                                showTimeSelect
                                timeCaption="time"
                                onChange={this.handleEndAtChange}/>
                        </div>
                        <div className="form-group inline">
                            <label>&nbsp;</label>
                            <button className="btn btn-primary" onClick={this.loadData}>
                                {t('shiftLists.filter.cta')}
                            </button>
                        </div>
                    </div>
                    <div className="hr-line-dashed"/>
                </div>
                {this.state.shiftsData.map((day, i) => (
                    <div key={i}>
                        <div className="row m-t">
                            <div className="col-xs-12">
                                <h2>
                                    <strong>
                                        {moment(day.date).format('DD.MM.YY HH:mm')}
                                    </strong>
                                </h2>
                            </div>
                            {day.routes.map((route, j) => (
                                <div className="col-xs-12" key={j}>
                                    <div className="ibox">
                                        <div className="ibox-title">
                                            <div className="ibox-tools pull-right">
                                                <a onClick={() => this.printRoute(route.id, route.name, day.date)}>
                                                    <i className="fa fa-print fa-2x"/>
                                                </a>
                                            </div>
                                            <h3>
                                                {route.name} ({t('default.waitingSpot.' + route.waitingSpot)})
                                            </h3>
                                        </div>
                                        <div className="ibox-content">
                                            {route.locations.map((location, k) => (
                                                <div key={k}>
                                                    <h3>
                                                        {location.name}
                                                    </h3>
                                                    <table className="table">
                                                        <tbody>
                                                        {location.shifts.map((shift, l) => (
                                                            <React.Fragment key={l}>
                                                                {shift.comments && shift.comments.map((comment, c) => (
                                                                    <tr key={`c-${l}-${c}`}>
                                                                        <td>
                                                                            <b>{comment.createdBy && comment.createdBy.username}:</b> <em>{comment.message}</em>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                                {(Array(shift.slots).fill(1)).map((x, i) => (
                                                                    <tr key={`s-${l}-${i}`}>
                                                                        <td>
                                                                            {shift.supporters[i] ? (
                                                                                    <Link
                                                                                        to={`/supporter/${shift.supporters[i].supporterId}`}
                                                                                        style={shift.supporters[i].handycap ? {textDecoration: 'underline'} : {}}>
                                                                                        {shift.supporters[i].name}
                                                                                    </Link>
                                                                                )
                                                                                : (
                                                                                    <span>&nbsp;</span>)}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </React.Fragment>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {day.locationsWithoutRoute.length > 0 ? (
                                <div className="col-xs-12">
                                    <div className="ibox">
                                        <div className="ibox-title">
                                            <div className="ibox-tools pull-right">
                                                <a onClick={() => this.printRoute(0, 'no_route', day.date)}>
                                                    <i className="fa fa-print fa-2x"/>
                                                </a>
                                            </div>
                                            <h3>
                                                {t('shiftLists.filter.locationsWithoutRoute')}
                                            </h3>
                                        </div>
                                        <div className="ibox-content">
                                            {day.locationsWithoutRoute.map((location, k) => (
                                                <div key={k}>
                                                    <h3>
                                                        {location.name}
                                                    </h3>
                                                    <table className="table">
                                                        <tbody>
                                                        {location.shifts.map((shift, l) => (
                                                            <React.Fragment key={l}>
                                                                {shift.comments && shift.comments.map((comment, c) => (
                                                                    <tr key={`c-${l}-${c}`}>
                                                                        <td>
                                                                            <b>{comment.createdBy && comment.createdBy.username}:</b> <em>{comment.message}</em>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                                {(Array(shift.slots).fill(1)).map((x, i) => (
                                                                    <tr key={`s-${l}-${i}`}>
                                                                        <td>
                                                                            {shift.supporters[i] ? (
                                                                                <span style={shift.supporters[i].handycap ? {textDecoration: 'underline'} : {}}>
                                                                                    {shift.supporters[i].name}
                                                                                </span>
                                                                            ) : (
                                                                                <span>&nbsp;</span>)}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </React.Fragment>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                ))}
            </div>
        )
    }
}

export default translate()(ShiftListsScreen);
